<table class="table table-striped table-responsive-lg" *ngIf="orders.length > 0">
  <thead>
  <tr>
    <th scope="col" class="text-center">#</th>
    <th scope="col" class="text-center">Start Time</th>
    <th scope="col" class="text-center">End Time</th>
    <th scope="col" class="text-center">Room</th>
    <th scope="col" class="text-center">Status</th>
    <th scope="col" class="text-center" *ngIf="isAdmin">Coffee Cups</th>
    <th scope="col" class="text-center">Door Code</th>
    <th scope="col" class="text-center">Auto renew</th>
    <th scope="col" class="text-center"></th>
    <th scope="col" class="text-center"></th>
    <th scope="col" class="text-center"></th>
  </tr>order
  </thead>
  <tbody>
  <tr *ngFor="let order of orders">
    <th scope="row">{{order.id}}</th>
    <td class="text-center">{{order.start | date:'dd.MM.yy HH:mm' }}</td>
    <td class="text-center">{{order.end | date:'dd.MM.yy HH:mm' }}</td>
    <td class="text-center">{{order.room.name}}</td>
    <td class="text-center">{{order.status}}</td>
    <td class="text-center" *ngIf="isAdmin">{{order.coffeeCups}}</td>
    <td class="text-center">
      <div *ngIf="order.status != 'CANCELLED' && order.status != 'FINISHED'" class="mx-auto text-center">
        <ng-container *ngFor="let door of order.doors">
          <label *ngIf="door.name=='Main Entrance'">{{door.code}}</label>
        </ng-container>
        <ng-container>
          <a [routerLink]="['/qr/' + order.qrToken]" class="btn btn-sm qr-button">QR</a>
        </ng-container>
      </div>
    </td>
    <td class="text-center">
      <div *ngIf="order.monthSubscribe" class="mx-auto text-center">
        {{'Yes '}} <a (click)="orderMonthSubscribeCancel(order.id)" class="btn btn-sm cancel-button">Cancel</a>
      </div>
      <div *ngIf="!order.monthSubscribe">
        {{'No'}}
      </div>
    </td>
    <td class="text-center">
      <div *ngIf="order.status != 'CANCELLED' && order.status != 'STARTED' && order.status != 'FINISHED'" class="mx-auto text-center">
        <a (click)="orderCancel(order.id)" class="btn btn-sm cancel-button">Cancel</a>
      </div>
    </td>
    <td class="text-center">
      <div *ngIf="order.status == 'PENDING'" class="mx-auto text-center">
        <a (click)="orderCheckout(order.id, order.duration, order.orderType)" class="btn btn-sm checkout-button">Checkout</a>
      </div>
    </td>
    <td class="text-center">
      <div *ngIf="order.transaction.status == 'PAID'" class="mx-auto text-center">
        <a (click)="invoice(order.transaction.id)" class="btn btn-sm invoice-button">Invoice</a>
      </div>
    </td>
    <td class="text-center">
      <div *ngIf="isAdmin && (order.bookingOption == 'ENTIRE_OFFICE_HOUR' || order.bookingOption == 'ENTIRE_OFFICE_HALF_DAY' || order.bookingOption == 'ENTIRE_OFFICE_FULL_DAY') && (order.status == 'READY' || order.status == 'STARTED')" class="mx-auto text-center">
        <a (click)="openEditModal(order)" class="btn btn-sm invoice-button">Visitor</a>
      </div>
    </td>
  </tr>
  </tbody>
</table>
<div *ngIf="orders.length == 0">
  <strong>You don't have orders yet.</strong>
</div>
